const Badge = () => {
  return {
    MuiBadge: {
      styleOverrides: {
        badge: () => ({
          fontWeight: '800',
        }),
      },
    },
  };
};

export default Badge;
